import React from 'react';

import BrandMark from './BrandMark';
import { InvalidTokenScreenStyles as S, ReviewScreenStyles as RS } from './styles';

const InvalidTokenScreen = ({ reason }) => (
  <S.PageWrap>
    <S.Content>
      <S.BrandRow>
        <BrandMark />
        <RS.Divider />
        <span>Scope form</span>
      </S.BrandRow>
      <S.Card>
        <S.Heading>This form link isn&apos;t valid</S.Heading>
        <S.Paragraph>
          It may have expired or been replaced. Reach out to your account team at Beam and they&apos;ll send you a fresh
          link.
        </S.Paragraph>
        {reason && <S.ReasonBox>{reason}</S.ReasonBox>}
      </S.Card>
    </S.Content>
  </S.PageWrap>
);

export default InvalidTokenScreen;
